export default function downloadFile(filename, data, type) {
  const file = new Blob([data], { type });
  const element = document.createElement('a');

  element.setAttribute('href', URL.createObjectURL(file));
  element.setAttribute('download', filename);
  element.click();
}
